<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>

        <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
    </div>

    <div class="topbar-end">
        <ul class="topbar-menu">
            <!-- <li class="topbar-search">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText placeholder="Search" class="w-12rem sm:w-full">
                </span>
            </li> -->
            <li class="topbar-profile">
                <span *ngIf="enteUOInfo" class="text-x block text-center"><strong>{{enteUOInfo.nameEnte}}</strong> - <strong>{{enteUOInfo.nameUO}}</strong></span>
            </li>                       
            <li class="topbar-profile">
                <span class="text-700 block text-center">{{userInfo.firstName + " " + userInfo.lastName + " ("+rolesString+")"}}</span>                
            </li>
            
            <li class="topbar-profile">
                <button type="button" class="p-link" (click)="onProfileButtonClick()">
                    <img src="assets/layout/images/avatar-user.png" alt="Profile" />
                </button>
            </li>
        </ul>
    </div>
</div>